////////////////////////////////////////////
// GLOBAL PROVIDERS — QUERY + WALLETS + AUTH
////////////////////////////////////////////
//
// ORDER MATTERS: WAGMI AND WALLET-ADAPTER SIT UNDER THE QUERY CLIENT (WAGMI
// USES IT), AND AUTH SITS UNDER BOTH SO SIGN-IN CAN TAKE EITHER WALLET'S
// signMessage. EVERYTHING ELSE READS THESE VIA HOOKS.
import type { ReactNode } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { SolanaProvider } from "@/app/providers/SolanaProvider";
import { EvmProvider } from "@/app/providers/EvmProvider";
import { AuthProvider } from "@/app/providers/AuthProvider";

// ONE CLIENT FOR THE APP LIFETIME — POLLING INTERVALS ARE SET PER-QUERY TO
// MIRROR THE VANILLA APP (LAUNCH DETAIL 5s, LISTS/MARKET 20s, PRICE 60s)
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

export function AppProviders({ children }: { children: ReactNode }) {

  return (
    <QueryClientProvider client={queryClient}>
      <EvmProvider>
        <SolanaProvider>
          <AuthProvider>{children}</AuthProvider>
        </SolanaProvider>
      </EvmProvider>
    </QueryClientProvider>
  );
}
